import React, { Component } from 'react';
import autobind from 'react-autobind';
import translate from 'app/translations';
import { BackTop, Button } from 'antd';

export class BackToTop extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  render() {
    return (
      <BackTop>
        <Button
          className="mobile-step-btn box-shadow"
          icon="arrow-up"
          shape="circle"
          title={this.t('Generic.top')}
        />
      </BackTop>
    );
  }
}

export default BackToTop;
